import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "docs-list" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = {
  key: 1,
  class: "documents"
}
const _hoisted_7 = { key: 2 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Loader = _resolveComponent("Loader")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "filter",
        disabled: !$props.format_filter
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.raw_filter) = $event)),
          type: "text",
          onKeyup: _cache[1] || (_cache[1] = _withKeys((...args) => ($options.onFilter && $options.onFilter(...args)), ["enter"]))
        }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
          [_vModelText, $data.raw_filter]
        ]),
        _createVNode(_component_Icon, {
          icon: "x-close",
          disabled: !$data.raw_filter,
          class: "icon-btn",
          onClick: $options.onResetFilter
        }, null, 8 /* PROPS */, ["disabled", "onClick"]),
        _createVNode(_component_Icon, {
          icon: "search",
          disabled: !$data.raw_filter,
          class: "icon-btn",
          onClick: $options.onFilter
        }, null, 8 /* PROPS */, ["disabled", "onClick"])
      ], 8 /* PROPS */, _hoisted_3),
      _createElementVNode("div", {
        class: "pager",
        disabled: $data.loading
      }, [
        _createTextVNode(_toDisplayString($data.skip) + " - " + _toDisplayString($data.skip + ($data.items || []).length) + " of " + _toDisplayString($data.total) + " ", 1 /* TEXT */),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Icon, {
            icon: "refresh-cw-05",
            class: "icon-btn",
            onClick: $options.onRefresh
          }, null, 8 /* PROPS */, ["onClick"]),
          _createVNode(_component_Icon, {
            icon: "chevron-left-double",
            class: "icon-btn",
            disabled: $data.skip==0,
            onClick: $options.onFirst
          }, null, 8 /* PROPS */, ["disabled", "onClick"]),
          _createVNode(_component_Icon, {
            icon: "chevron-left",
            class: "icon-btn",
            disabled: $data.skip==0,
            onClick: $options.onPrev
          }, null, 8 /* PROPS */, ["disabled", "onClick"]),
          _createVNode(_component_Icon, {
            icon: "chevron-right",
            class: "icon-btn",
            disabled: $data.skip + $data.limit > $data.total,
            onClick: $options.onNext
          }, null, 8 /* PROPS */, ["disabled", "onClick"]),
          _createVNode(_component_Icon, {
            icon: "chevron-right-double",
            class: "icon-btn",
            disabled: $data.skip + $data.limit > $data.total,
            onClick: $options.onLast
          }, null, 8 /* PROPS */, ["disabled", "onClick"])
        ])
      ], 8 /* PROPS */, _hoisted_4)
    ]),
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
      : ($data.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.docs, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "document"
              }, [
                _createVNode($setup["Tree"], {
                  "expanded-keys": item.expanded_keys,
                  "onUpdate:expandedKeys": $event => ((item.expanded_keys) = $event),
                  value: item.nodes,
                  unstyled: false,
                  class: "tree"
                }, {
                  default: _withCtx((props) => [
                    _createElementVNode("b", null, _toDisplayString(props.node.label), 1 /* TEXT */),
                    _cache[2] || (_cache[2] = _createTextVNode(": ")),
                    _createElementVNode("span", {
                      class: _normalizeClass(["value", {str: props.node.is_str, date: props.node.is_date}])
                    }, _toDisplayString(props.node.data), 3 /* TEXT, CLASS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["expanded-keys", "onUpdate:expandedKeys", "value"])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, " There are no documents "))
  ]))
}